import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

const Contact = () => {

    const [openedFAQ, setOpenedFAQ] = useState(null);
    const [formStatus, setFormStatus] = useState(''); // 'success', 'error', or ''

    const toggleFAQ = (index) => {
        if (openedFAQ === index) {
            setOpenedFAQ(null); // Aynı soruya tıklanırsa kapat
        } else {
            setOpenedFAQ(index);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.target;
        const data = new FormData(form);

        try {
            const response = await fetch('https://formspree.io/f/mrbonrwp', {
                method: 'POST',
                body: data,
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (response.ok) {
                console.log('✅ Mesaj başarıyla gönderildi!');
                console.log('Form verileri:', Object.fromEntries(data));
                setFormStatus('success');
                form.reset();
                setTimeout(() => setFormStatus(''), 5000);
            } else {
                console.error('❌ Form gönderimi başarısız:', response.status);
                setFormStatus('error');
                setTimeout(() => setFormStatus(''), 5000);
            }
        } catch (error) {
            console.error('❌ Form gönderimi sırasında hata oluştu:', error);
            setFormStatus('error');
            setTimeout(() => setFormStatus(''), 5000);
        }
    };

    const faqs = [
        { question: "ZENON Gaming PC leriyle hangi oyunları oynayabilirim ?", answer: "Bir oyun bilgisayarının tüm oyunları oynayabilmesi için, her bir donanım bileşeninin, oynamak istediğiniz oyunların minimum sistem gereksinimlerini karşılaması gerekir. Minimum sistem gereksinimlerini karşılayan bir bilgisayar, oyunu oynamanıza izin verecek olsa da, en iyi oyun deneyimini sunmayabilir. Daha yüksek kare hızları ve daha iyi görsel kalite istiyorsanız, önerilen sistem gereksinimlerini karşılayan bir bilgisayara ihtiyacınız olacaktır." },
        { question: "PC seçerken nelere dikkat etmeliyim ?", answer: "Oyun bilgisayarı satın almadan önce, oynamak istediğiniz oyunların sistem gereksinimlerini kontrol etmeniz önemlidir. Ayrıca, bütçenizi ve ihtiyaçlarınızı göz önünde bulundurmanız gerekir" },
        { question: "ZENON Gaming PC leri nereden temin edebilirim ?", answer: "Türkiyede'ki tüm seçkin online pazaryerleri ve Zenon Bayilerinden temin edebilirsiniz." },
        { question: "Garanti süreniz kaç yıl ?", answer: "Tüm Zenon Markalı Ürünlerimiz 3 Yıl Garantilidir." },
    ];

    return (
        <section
            id="contact"
            className="min-h-screen flex flex-col justify-center pt-20 pb-12 bg-cover bg-center relative"
            style={{ backgroundImage: 'url("/Images/contact-background.jpg")' }}
        >
            <div className="absolute inset-0 bg-black bg-opacity-50"></div>

            <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

                {/* Desktop Layout (lg ve üzeri) */}
                <div className="hidden lg:flex justify-center gap-8 xl:gap-16 2xl:gap-24">

                    {/* Left Side - FAQ Section */}
                    <div id="leftside" className="flex-1 max-w-lg xl:max-w-xl">
                        <div className="flex flex-col gap-3 mb-6">
                            <p className="uppercase font-montserrat text-white text-sm xl:text-base">Sorular</p>
                            <p className="text-white font-montserrat font-bold text-xl xl:text-2xl uppercase">Sık sorulan sorular</p>
                            <hr className="border-white" />
                        </div>

                        <div className="space-y-1">
                            {faqs.map((faq, index) => (
                                <div key={index} className="py-3 border-b border-white/20">
                                    <button
                                        onClick={() => toggleFAQ(index)}
                                        className="w-full text-left flex justify-between items-center text-white font-montserrat font-semibold hover:text-[#ad2831] transition-colors text-sm xl:text-base"
                                    >
                                        <span className="pr-4">{faq.question}</span>
                                        <span className="flex-shrink-0">{openedFAQ === index ? <FiChevronUp /> : <FiChevronDown />}</span>
                                    </button>
                                    <div
                                        className={`mt-2 text-white/90 font-montserrat overflow-hidden transition-all ease-in-out duration-300 text-sm xl:text-base leading-relaxed ${openedFAQ === index ? "max-h-[300px] opacity-100" : "max-h-0 opacity-0"
                                            }`}
                                    >
                                        {faq.answer}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right Side - Contact Form */}
                    <div id="rightside" className="flex-1 max-w-lg xl:max-w-xl">
                        <form className="space-y-6" onSubmit={handleSubmit}>
                            <div className="flex flex-col gap-2">
                                <h3 className="text-white font-montserrat text-lg xl:text-xl">BİZE ULAŞIN</h3>
                                <h1 className="text-white uppercase font-montserrat font-bold text-xl xl:text-2xl leading-tight">Her türlü sorunuz için bize ulaşın.</h1>
                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div className="flex flex-col gap-2">
                                    <p className="text-white font-lato text-sm xl:text-base">İsim</p>
                                    <input
                                        type="text"
                                        name="firstName"
                                        required
                                        className="border border-gray-500 px-3 py-2 xl:px-4 xl:py-3 w-full bg-transparent text-white placeholder-gray-400 focus:border-white focus:outline-none transition-colors text-sm xl:text-base"
                                    />
                                </div>

                                <div className="flex flex-col gap-2">
                                    <p className="text-white font-lato text-sm xl:text-base">Soyisim</p>
                                    <input
                                        type="text"
                                        name="lastName"
                                        required
                                        className="border border-gray-500 px-3 py-2 xl:px-4 xl:py-3 w-full bg-transparent text-white placeholder-gray-400 focus:border-white focus:outline-none transition-colors text-sm xl:text-base"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col gap-2">
                                <p className="text-white font-lato text-sm xl:text-base">E-posta Adresiniz</p>
                                <input
                                    type="email"
                                    name="email"
                                    className="border border-gray-500 px-3 py-2 xl:px-4 xl:py-3 w-full bg-transparent text-white placeholder-gray-400 focus:border-white focus:outline-none transition-colors text-sm xl:text-base"
                                    required
                                />
                            </div>

                            <div className="flex flex-col gap-2">
                                <p className="text-white font-lato text-sm xl:text-base">Konu</p>
                                <select
                                    name="subject"
                                    required
                                    className="border border-gray-500 px-3 py-2 xl:px-4 xl:py-3 w-full bg-transparent text-white focus:border-white focus:outline-none transition-colors text-sm xl:text-base cursor-pointer"
                                >
                                    <option value="" className="bg-[#252525] text-gray-400">Konu seçiniz</option>
                                    <option value="Garanti" className="bg-[#252525]">Garanti</option>
                                    <option value="Teknik Servis" className="bg-[#252525]">Teknik Servis</option>
                                    <option value="Ürün Bilgisi" className="bg-[#252525]">Ürün Bilgisi</option>
                                    <option value="Başka Bir Konu" className="bg-[#252525]">Başka Bir Konu</option>
                                </select>
                            </div>

                            <div className="flex flex-col gap-2">
                                <p className="text-white font-lato text-sm xl:text-base">Mesajınız</p>
                                <textarea
                                    name="message"
                                    className="border border-gray-500 px-3 py-2 xl:px-4 xl:py-3 w-full bg-transparent text-white placeholder-gray-400 focus:border-white focus:outline-none transition-colors resize-none text-sm xl:text-base"
                                    rows="5"
                                    required
                                ></textarea>
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    className="bg-white px-4 py-3 xl:px-6 xl:py-4 text-base xl:text-lg font-montserrat font-bold text-black hover:bg-[#540b0e] hover:text-white transition-colors w-full"
                                >
                                    GÖNDER
                                </button>
                            </div>

                            {formStatus === 'success' && (
                                <div className="bg-green-500 text-white px-4 py-3 rounded font-montserrat text-center">
                                    Mesajınız başarıyla gönderildi!
                                </div>
                            )}
                            {formStatus === 'error' && (
                                <div className="bg-red-500 text-white px-4 py-3 rounded font-montserrat text-center">
                                    Bir hata oluştu. Lütfen tekrar deneyin.
                                </div>
                            )}
                        </form>
                    </div>

                </div>

                {/* Tablet Layout (md ve lg arası) */}
                <div className="hidden md:flex lg:hidden flex-col items-center space-y-8">

                    {/* FAQ Section - Tablet */}
                    <div className="w-full max-w-2xl">
                        <div className="flex flex-col gap-3 mb-6 text-center">
                            <p className="uppercase font-montserrat text-white text-sm">Sorular</p>
                            <p className="text-white font-montserrat font-bold text-xl uppercase">Sık sorulan sorular</p>
                            <hr className="border-white mx-auto w-24" />
                        </div>

                        <div className="space-y-1">
                            {faqs.map((faq, index) => (
                                <div key={index} className="py-3 border-b border-white/20">
                                    <button
                                        onClick={() => toggleFAQ(index)}
                                        className="w-full text-left flex justify-between items-center text-white font-montserrat font-semibold hover:text-[#ad2831] transition-colors"
                                    >
                                        <span className="pr-4">{faq.question}</span>
                                        <span className="flex-shrink-0">{openedFAQ === index ? <FiChevronUp /> : <FiChevronDown />}</span>
                                    </button>
                                    <div
                                        className={`mt-2 text-white/90 font-montserrat overflow-hidden transition-all ease-in-out duration-300 leading-relaxed ${openedFAQ === index ? "max-h-[300px] opacity-100" : "max-h-0 opacity-0"
                                            }`}
                                    >
                                        {faq.answer}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Contact Form - Tablet */}
                    <div className="w-full max-w-2xl">
                        <form className="space-y-6" onSubmit={handleSubmit}>
                            <div className="flex flex-col gap-2 text-center">
                                <h3 className="text-white font-montserrat text-lg">BİZE ULAŞIN</h3>
                                <h1 className="text-white uppercase font-montserrat font-bold text-xl">Her türlü sorunuz için bize ulaşın.</h1>
                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div className="flex flex-col gap-2">
                                    <p className="text-white font-lato">İsim</p>
                                    <input
                                        type="text"
                                        name="firstName"
                                        required
                                        className="border border-gray-500 px-4 py-3 w-full bg-transparent text-white placeholder-gray-400 focus:border-white focus:outline-none transition-colors"
                                    />
                                </div>

                                <div className="flex flex-col gap-2">
                                    <p className="text-white font-lato">Soyisim</p>
                                    <input
                                        type="text"
                                        name="lastName"
                                        required
                                        className="border border-gray-500 px-4 py-3 w-full bg-transparent text-white placeholder-gray-400 focus:border-white focus:outline-none transition-colors"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col gap-2">
                                <p className="text-white font-lato">E-posta Adresiniz</p>
                                <input
                                    type="email"
                                    name="email"
                                    className="border border-gray-500 px-4 py-3 w-full bg-transparent text-white placeholder-gray-400 focus:border-white focus:outline-none transition-colors"
                                    required
                                />
                            </div>

                            <div className="flex flex-col gap-2">
                                <p className="text-white font-lato">Konu</p>
                                <select
                                    name="subject"
                                    required
                                    className="border border-gray-500 px-4 py-3 w-full bg-transparent text-white focus:border-white focus:outline-none transition-colors cursor-pointer"
                                >
                                    <option value="" className="bg-[#252525] text-gray-400">Konu seçiniz</option>
                                    <option value="Garanti" className="bg-[#252525]">Garanti</option>
                                    <option value="Teknik Servis" className="bg-[#252525]">Teknik Servis</option>
                                    <option value="Ürün Bilgisi" className="bg-[#252525]">Ürün Bilgisi</option>
                                    <option value="Başka Bir Konu" className="bg-[#252525]">Başka Bir Konu</option>
                                </select>
                            </div>

                            <div className="flex flex-col gap-2">
                                <p className="text-white font-lato">Mesajınız</p>
                                <textarea
                                    name="message"
                                    className="border border-gray-500 px-4 py-3 w-full bg-transparent text-white placeholder-gray-400 focus:border-white focus:outline-none transition-colors resize-none"
                                    rows="5"
                                    required
                                ></textarea>
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    className="bg-white px-6 py-4 text-lg font-montserrat font-bold text-black hover:bg-[#540b0e] hover:text-white transition-colors w-full"
                                >
                                    GÖNDER
                                </button>
                            </div>

                            {formStatus === 'success' && (
                                <div className="bg-green-500 text-white px-4 py-3 rounded font-montserrat text-center">
                                    Mesajınız başarıyla gönderildi!
                                </div>
                            )}
                            {formStatus === 'error' && (
                                <div className="bg-red-500 text-white px-4 py-3 rounded font-montserrat text-center">
                                    Bir hata oluştu. Lütfen tekrar deneyin.
                                </div>
                            )}
                        </form>
                    </div>

                </div>

                {/* Mobile Layout (md altı) */}
                <div className="md:hidden space-y-8">

                    {/* FAQ Section - Mobile */}
                    <div className="w-full">
                        <div className="flex flex-col gap-3 mb-6 text-center">
                            <p className="uppercase font-montserrat text-white text-xs sm:text-sm">Sorular</p>
                            <p className="text-white font-montserrat font-bold text-lg sm:text-xl uppercase">Sık sorulan sorular</p>
                            <hr className="border-white mx-auto w-20" />
                        </div>

                        <div className="space-y-1">
                            {faqs.map((faq, index) => (
                                <div key={index} className="py-2 sm:py-3 border-b border-white/20">
                                    <button
                                        onClick={() => toggleFAQ(index)}
                                        className="w-full text-left flex justify-between items-start text-white font-montserrat font-semibold hover:text-[#ad2831] transition-colors text-xs sm:text-sm"
                                    >
                                        <span className="pr-3 leading-tight">{faq.question}</span>
                                        <span className="flex-shrink-0 mt-1">{openedFAQ === index ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}</span>
                                    </button>
                                    <div
                                        className={`mt-2 text-white/90 font-montserrat overflow-hidden transition-all ease-in-out duration-300 text-xs sm:text-sm leading-relaxed ${openedFAQ === index ? "max-h-[250px] opacity-100" : "max-h-0 opacity-0"
                                            }`}
                                    >
                                        {faq.answer}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Contact Form - Mobile */}
                    <div className="w-full">
                        <form className="space-y-4 sm:space-y-6" onSubmit={handleSubmit}>
                            <div className="flex flex-col gap-2 text-center">
                                <h3 className="text-white font-montserrat text-base sm:text-lg">BİZE ULAŞIN</h3>
                                <h1 className="text-white uppercase font-montserrat font-bold text-lg sm:text-xl leading-tight">Her türlü sorunuz için bize ulaşın.</h1>
                            </div>

                            <div className="space-y-4">
                                <div className="grid grid-cols-2 gap-4">
                                    <div className="flex flex-col gap-2">
                                        <p className="text-white font-lato text-sm">İsim</p>
                                        <input
                                            type="text"
                                            name="firstName"
                                            required
                                            className="border border-gray-500 px-3 py-2 sm:px-4 sm:py-3 w-full bg-transparent text-white placeholder-gray-400 focus:border-white focus:outline-none transition-colors text-sm"
                                        />
                                    </div>

                                    <div className="flex flex-col gap-2">
                                        <p className="text-white font-lato text-sm">Soyisim</p>
                                        <input
                                            type="text"
                                            name="lastName"
                                            required
                                            className="border border-gray-500 px-3 py-2 sm:px-4 sm:py-3 w-full bg-transparent text-white placeholder-gray-400 focus:border-white focus:outline-none transition-colors text-sm"
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-col gap-2">
                                    <p className="text-white font-lato text-sm">E-posta Adresiniz</p>
                                    <input
                                        type="email"
                                        name="email"
                                        className="border border-gray-500 px-3 py-2 sm:px-4 sm:py-3 w-full bg-transparent text-white placeholder-gray-400 focus:border-white focus:outline-none transition-colors text-sm"
                                        required
                                    />
                                </div>

                                <div className="flex flex-col gap-2">
                                    <p className="text-white font-lato text-sm">Konu</p>
                                    <select
                                        name="subject"
                                        required
                                        className="border border-gray-500 px-3 py-2 sm:px-4 sm:py-3 w-full bg-transparent text-white focus:border-white focus:outline-none transition-colors text-sm cursor-pointer"
                                    >
                                        <option value="" className="bg-[#252525] text-gray-400">Konu seçiniz</option>
                                        <option value="Garanti" className="bg-[#252525]">Garanti</option>
                                        <option value="Teknik Servis" className="bg-[#252525]">Teknik Servis</option>
                                        <option value="Ürün Bilgisi" className="bg-[#252525]">Ürün Bilgisi</option>
                                        <option value="Başka Bir Konu" className="bg-[#252525]">Başka Bir Konu</option>
                                    </select>
                                </div>

                                <div className="flex flex-col gap-2">
                                    <p className="text-white font-lato text-sm">Mesajınız</p>
                                    <textarea
                                        name="message"
                                        className="border border-gray-500 px-3 py-2 sm:px-4 sm:py-3 w-full bg-transparent text-white placeholder-gray-400 focus:border-white focus:outline-none transition-colors resize-none text-sm"
                                        rows="4"
                                        required
                                    ></textarea>
                                </div>
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    className="bg-white px-4 py-3 sm:px-6 sm:py-4 text-base sm:text-lg font-montserrat font-bold text-black hover:bg-[#540b0e] hover:text-white transition-colors w-full"
                                >
                                    GÖNDER
                                </button>
                            </div>

                            {formStatus === 'success' && (
                                <div className="bg-green-500 text-white px-4 py-3 rounded font-montserrat text-center text-sm sm:text-base">
                                    Mesajınız başarıyla gönderildi!
                                </div>
                            )}
                            {formStatus === 'error' && (
                                <div className="bg-red-500 text-white px-4 py-3 rounded font-montserrat text-center text-sm sm:text-base">
                                    Bir hata oluştu. Lütfen tekrar deneyin.
                                </div>
                            )}
                        </form>
                    </div>

                </div>

            </div>
        </section>
    );
}

export default Contact;